import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.m,
  },
}))
